/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { createTheme } from '@mui/material/styles';

const { palette } = createTheme();
const { augmentColor } = palette;
const createColor = (mainColor) => augmentColor({ color: { main: mainColor } });
const theme = createTheme({
    palette: {
      dark: createColor('#161616'),
      primary: createColor('#1976d2'),
      secondary: createColor('#dc004e'),
    },
    typography: {
      fontFamily: 'Inter, sans-serif',
    }
  });

export default theme;
